import React, { useEffect, useState } from "react";
import html2canvas from 'html2canvas'
import JSPDF from 'jspdf'
import toPx from 'unit-to-px'
import './print.css';
import VesselPrint from "../Components/PrintComponents/VesselPrint";
import prints from '../images/prints.svg';
import { useDispatch, useSelector } from "react-redux";
import lang from './library';
import { setPrintLang } from "../Components/Store/LoadReducer";
import { customAxios, fileStorage } from "../helpers/utils";

function Print() {

    const uploadedVessels = useSelector(item => item.flowviewer.uploadedVessels);
    const langs = useSelector(item => item.flowviewer.printLang);
    const allowedLanguages = useSelector(item => item.flowviewer.allowedLanguages);
    const dispatch = useDispatch();
    const [currentLangs, setCurrentLangs] = useState(false);
    const ids = Object.keys(uploadedVessels).map((vessel) => "print-" + vessel);

    const getLangs = () => {
        setCurrentLangs(lang[langs]);
    };

    useEffect(() => {
        getLangs();
    }, [langs]);

    const print = async (pages) => {
        let images = [];
        await Promise.all(pages.map(async value => {
            const input = document.getElementById(value);
            const promise = new Promise(
                resolve => html2canvas(input, {
                    allowTaint: true,
                    logging: false,
                    dpi: 300,
                    scale: 4
                }).then(canvas => {
                    resolve(canvas)
                })
            )
            await Promise.all([promise]).then(canvas => {
                const image = canvas[0].toDataURL('image/png', 1.0)
                images.push(image)
            })
        }));
        const download = async (images) => {
            const pdf = new JSPDF({
                format: 'a4',
                resolution: 300,
                compress: true
            })
            const pages = document.getElementById('pages').offsetHeight / toPx('297mm')
            for (let i = 0; i < Math.trunc(pages); i++) {
                i > 0 && i < Math.trunc(pages) && pdf.addPage()
                pdf.addImage(images[i], 'PNG', 0, 0, pdf.internal.pageSize.getWidth(), pdf.internal.pageSize.getHeight(), undefined, 'FAST')
            }
            const pdfBlob = pdf.output('blob');
            const formData = new FormData();
            formData.append('file', pdfBlob, 'download.pdf');

            customAxios().post('/file/report/send', formData, { headers: {'Content-Type': 'multipart/form-data'} })
                .then(() => pdf.save('download.pdf'))
                .catch(error => {
                    // TODO: log error
                });
        };
        images.length > 0 && download(images);
    }

    return (

        <div className="d-grid">
            <div className="btn-groups d-flex align-items-center justify-content-between">
                <select value={langs} onChange={(e) => dispatch(setPrintLang(e.target.value))}>
                    {
                        allowedLanguages.map((option, index) => (
                            <option key={"lang-" + index} value={option}>
                                {option}
                            </option>
                        ))
                    }
                </select>
                <button className="toogle-control m-0 active" onClick={() => print(ids)}>
                    <img className="w-100" src={prints} />
                </button>
            </div>
            <div id='pages'>
                {
                    Object.keys(uploadedVessels).map((vessel) =>
                        <VesselPrint
                            id={"print-" + vessel}
                            key={"print-" + vessel}
                            vessel={vessel}
                        />
                    )
                }
            </div>
        </div>
    );
}

export default Print;